// ---------- CONFIG: change these to match your project ----------
// Base URL of your Express server. Include "/api" here if your routes are mounted under it.
export const API = import.meta.env.VITE_API_URL || 'https://jeetayu.api.aadviktech.com'
// Where multer saves uploads and how they are served (app.use('/uploads', express.static('uploads'))).
export const IMG_BASE = `${API}/uploads/`
// localStorage key where your login page saves the JWT.
export const TOKEN_KEYS = ['token', 'accessToken', 'authToken', 'jwt'] // the first one found is used
export const TOKEN_KEY = TOKEN_KEYS[0]
export const getToken = () => {
  for (const k of TOKEN_KEYS) {
    const v = localStorage.getItem(k)
    if (v) return v.replace(/^"|"$/g, '')
  }
  return null
}

// Route prefixes exactly as mounted in your server (app.use('/products', ...) etc.)
export const ROUTES = {
  me: '/users/me', // returns { id, name, email, phone, role }
  products: '/products',
  categories: '/category',
  // admin uses your existing order/review routes: the admin gets everyone's data with ?all=1
  adminOrders: '/orders',
  adminOrdersAll: '/orders?all=1',
  adminUsers: '/users', // GET /users (admin only)
  adminReviews: '/reviews',
  adminReviewsAll: '/reviews?all=1',
  adminBanners: '/banners',
  adminBannersAll: '/banners/all', // admin list, includes hidden banners
  settings: '/settings',
  adminSettings: '/admin/settings',
  about: '/about',
  contactInfo: '/contactinfo',
  headerInfo:'/headerinfo',
  footerinfo:'/footerinfo',
  coupons: '/coupons',
}

// Your PUT /category/:id has no upload middleware, so images can't be changed on edit yet.
// Set to true after adding upload.single('image') to that route and updating the controller.
export const FEATURES = { categoryImageEdit: true }
// -----------------------------------------------------------------

export const imgUrl = (f) => (!f ? null : /^(https?:|data:|blob:)/.test(f) ? f : IMG_BASE + f)

async function request(method, path, { body, form } = {}) {
  const headers = {}
  const token = getToken()
  if (token) headers.Authorization = `Bearer ${token}`
  let payload
  if (form) payload = form
  else if (body !== undefined) {
    headers['Content-Type'] = 'application/json'
    payload = JSON.stringify(body)
  }
  let res
  try {
    res = await fetch(API + path, { method, headers, body: payload })
  } catch {
    throw Object.assign(new Error('Could not reach the server. Check that the API is running.'), { status: 0 })
  }
  const data = await res.json().catch(() => null)
  if (!res.ok) {
    throw Object.assign(new Error(data?.message || data?.error || `Request failed (${res.status})`), { status: res.status })
  }
  return data
}

export const api = {
  get: (p) => request('GET', p),
  post: (p, body) => request('POST', p, { body }),
  put: (p, body) => request('PUT', p, { body }),
  patch: (p, body) => request('PATCH', p, { body }),
  del: (p) => request('DELETE', p),
  upload: (method, p, form) => request(method, p, { form }),
}

// Builds FormData and leaves out empty values, so the backend's "?? null" defaults apply.
export function toFormData(obj) {
  const fd = new FormData()
  Object.entries(obj).forEach(([k, v]) => {
    if (v === '' || v === null || v === undefined) return
    fd.append(k, v)
  })
  return fd
}
